import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    repeatIcon: {
      width: 24,
      height: 24,
      [theme.breakpoints.up('sm')]: {
        width: 37,
        height: 37,
      },
    },
  }),
);
export default useStyles;
